import * as sumTypes from '../constaints/header';

export const changeHeader = (value => {
    return {
        type: sumTypes.CHANGE_HEADER,
        payload: value,
    }
});
